/// <reference path="controllers/AdminAlarmsTemplatesController.ts" />
/// <reference path="controllers/AdminAlarmsServicesController.ts" />
/// <reference path="controllers/AdminAlarmsSpecificsController.ts" />
/// <reference path="controllers/AdminBundlesController.ts" />
/// <reference path="controllers/AdminEventsController.ts" />
/// <reference path="controllers/AdminInventoryController.ts" />
/// <reference path="controllers/AdminUserController.ts" />
/// <reference path="controllers/AdminUsersController.ts" />
/// <reference path="controllers/AdminVnoController.ts" />
/// <reference path="controllers/AdminVnoGroupController.ts" />
/// <reference path="controllers/AdminVnosController.ts" />
/// <reference path="controllers/ConnectionRoomParentController.ts" />
/// <reference path="controllers/ConnectionRoomController.ts" />
/// <reference path="controllers/DeviceMapController.ts" />
/// <reference path="controllers/FlexServicesController.ts" />
/// <reference path="controllers/GridController.ts" />
/// <reference path="controllers/LoginController.ts" />
/// <reference path="controllers/HistoricalTrendingController.ts" />
/// <reference path="controllers/MainController.ts" />
/// <reference path="controllers/MatrixRoomController.ts" />
/// <reference path="controllers/MessageTranslationController.ts" />
/// <reference path="controllers/MobileDevicesController.ts" />
/// <reference path="controllers/MobileDevicesDashboardController.ts" />
/// <reference path="controllers/MonitoringRoomController.ts" />
/// <reference path="controllers/MultiBlockController.ts" />
/// <reference path="controllers/NetworkMapController.ts" />
/// <reference path="controllers/NetworkNodesController.ts" />
/// <reference path="controllers/RedundantBlocksController.ts" />
/// <reference path="controllers/NodeSupportController.ts" />
/// <reference path="controllers/PipeViewerController.ts" />
/// <reference path="controllers/DigiconViewerController.ts" />
/// <reference path="controllers/ProbeController.ts" />
/// <reference path="controllers/ProbeJobsController.ts" />
/// <reference path="controllers/RecordingsExportsController.ts" />
/// <reference path="controllers/SimPlanController.ts" />
/// <reference path="controllers/SimsController.ts" />
/// <reference path="controllers/SimUsageController.ts" />
/// <reference path="controllers/admin/preset-paths/PresetPathsController.ts" />
/// <reference path="controllers/StreamDetailsController.ts" />
/// <reference path="controllers/SystemAlarmsController.ts" />
/// <reference path="controllers/TsProbeController.ts" />
/// <reference path="controllers/UserController.ts" />

namespace Application {
    'use strict';

    export const googleMapsApiKey: string = 'AIzaSyAZKp_C53xYM2XpAnoRBAkSjXPS_loeiAw';

    flexPortalAppConfig.$inject = ['$routeProvider',
                                   '$animateProvider',
                                   '$locationProvider',
                                   '$compileProvider',
                                   '$httpProvider',
                                   'uiGmapGoogleMapApiProvider',
                                   'ChartJsProvider'];

    export function flexPortalAppConfig($routeProvider: ng.route.IRouteProvider,
                                        $animateProvider: ng.animate.IAnimateProvider,
                                        $locationProvider: ng.ILocationProvider,
                                        $compileProvider: ng.ICompileProvider,
                                        $httpProvider: ng.IHttpProvider,
                                        googleMapApiProvider: google.maps.custom.IApiProvider): void {

        $httpProvider.defaults.withCredentials = true;
        
        $httpProvider.interceptors.push(Services.PreventTemplateCacheService.$name);

        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|srtflex):/);

        googleMapApiProvider.configure({
            key: googleMapsApiKey,
            libraries: 'weather,geometry,places,visualization',
        });

        $animateProvider.classNameFilter(new RegExp('angular-animate'));

        $locationProvider.hashPrefix('!');

        $routeProvider
            .when('/login', {
                templateUrl: 'views/login.html',
                controller: Controllers.LoginController.$name,
                controllerAs: 'log',
            })
            .when('/logout', {
                templateUrl: 'views/login.html',
                controller: Controllers.LoginController.$name,
                controllerAs: 'log',
            })
            .when('/network-nodes', {
                templateUrl: 'views/network-nodes.html',
                controller: Controllers.NetworkNodesController.$name,
                controllerAs: 'nno',
            })
            .when('/admin/probes', {
                templateUrl: 'views/probes.html',
                controller: Controllers.ProbeController.$name,
                controllerAs: 'pro',
            })
            .when('/admin/probes/:probeId/jobs', {
                templateUrl: 'views/probejobs.html',
                controller: Controllers.ProbeJobsController.$name,
                controllerAs: 'pjo',
            })
            .when('/network-map', {
                templateUrl: 'views/network-map.html',
                controller: Controllers.NetworkMapController.$name,
                controllerAs: 'nmc',
            })
            .when('/network-map/:type/:id', {
                templateUrl: 'views/network-map.html',
                controller: Controllers.NetworkMapController.$name,
                controllerAs: 'nmc',
            })
            .when('/connection-room', {
                templateUrl: 'views/connection-room.html',
                controller: Controllers.ConnectionRoomController.$name,
                controllerAs: 'crc',
            })
            .when('/matrix-room', {
                templateUrl: 'views/matrix-room.html',
                controller: Controllers.MatrixRoomController.$name,
                controllerAs: 'mcr',
            })
            .when('/monitoring-room', {
                templateUrl: 'views/monitoring.html',
                controller: Controllers.MonitoringRoomController.$name,
                controllerAs: 'mrc',
            })
            .when('/multiviewer', {
                templateUrl: 'views/grid.html',
                controller: Controllers.GridController.$name,
                controllerAs: 'grc',
                reloadOnSearch: false
            })
            .when('/pipe/:streamId', {
                templateUrl: 'views/pipe-viewer.html',
                controller: Controllers.PipeViewerController.$name,
                controllerAs: 'pvc',
            })
            .when('/stream/:streamId', {
                templateUrl: 'views/stream-details.html',
                controller: Controllers.StreamDetailsController.$name,
                controllerAs: 'sdc',
            })
            .when('/historical/:streamId', {
                templateUrl: 'views/historical-trending-view.html',
                controller: Controllers.HistoricalTrendingController.$name,
                controllerAs: 'hst',
            })
            .when('/historicalByClient/:clientId/:blockId?', {
                templateUrl: 'views/historical-trending-view.html',
                controller: Controllers.HistoricalTrendingController.$name,
                controllerAs: 'hst',
            })
            .when('/historicalByClass/:class/:id/:param', {
                templateUrl: 'views/historical-trending-view.html',
                controller: Controllers.HistoricalTrendingController.$name,
                controllerAs: 'hst',
            })
            .when('/historicalByDataPorts/:sourceId/:sinkId/:param', {
                templateUrl: 'views/historical-trending-view.html',
                controller: Controllers.HistoricalTrendingController.$name,
                controllerAs: 'hst',
            })
            .when('/historicalByDigicon/:class/:sourceId/:title/:param', {
                templateUrl: 'views/historical-trending-view.html',
                controller: Controllers.HistoricalTrendingController.$name,
                controllerAs: 'hst',
            })
            .when('/admin/sims', {
                templateUrl: 'views/sims.html',
                controller: Controllers.SimsController.$name,
                controllerAs: 'scc',
            })
            .when('/admin/sims/:selectedSim', {
                templateUrl: 'views/sim-usage.html',
                controller: Controllers.SimUsageController.$name,
                controllerAs: 'suc',
            })
            .when('/admin/sim-plans', {
                templateUrl: 'views/sim-plan.html',
                controller: Controllers.SimPlanController.$name,
                controllerAs: 'spl',
            })
            .when('/admin/recordings-exports', {
                templateUrl: 'views/recordings-exports.html',
                controller: Controllers.RecordingsExportsController.$name,
                controllerAs: 'rec',
            })
            .when('/admin/mobile-devices', {
                templateUrl: 'views/mobile-devices.html',
                controller: Controllers.MobileDevicesController.$name,
                controllerAs: 'mdc',
            })
            .when('/admin/mobile-devices/:deviceId', {
                templateUrl: 'views/mobile-device-dashboard.html',
                controller: Controllers.MobileDevicesDashboardController.$name,
                controllerAs: 'mdashc',
            })
            .when('/admin/device-map', {
                templateUrl: 'views/device-map.html',
                controller: Controllers.DeviceMapController.$name,
                controllerAs: 'dmc',
            })
            .when('/admin/bundles', {
                templateUrl: 'views/admin-bundles.html',
                controller: Controllers.AdminBundlesController.$name,
                controllerAs: 'bdc',
            })
            .when('/support/:nodeId/:backUrl?', {
                templateUrl: 'views/node-support.html',
                controller: Controllers.NodeSupportController.$name,
                controllerAs: 'sup',
            })
            .when('/support-toolkit', {
                templateUrl: 'views/support-toolkit.html',
                controller: Controllers.NetworkNodesController.$name,
                controllerAs: 'nno',
            })
            .when('/admin/redundant-blocks', {
                templateUrl: 'views/admin-redundant-blocks.html',
                controller: Controllers.RedundantBlocksController.$name,
                controllerAs: 'rb',
            })
            .when('/digicon-viewer', {
                templateUrl: 'views/digicon-viewer.html',
                controller: Controllers.DigiconViewerController.$name,
                controllerAs: 'dvc',
            })
            .when('/currentUser', {
                templateUrl: 'views/user.html',
                controller: Controllers.UserController.$name,
                controllerAs: 'uc',
            })
            .when('/ts-probes/:id?/:portId?', {
                templateUrl: 'views/ts-probe-interfaces.html',
                controller: Application.Controllers.TsProbeController.$name,
                controllerAs: 'tsp',
            })
            .when('/admin/users', {
                templateUrl: 'views/admin-users.html',
                controller: Controllers.AdminUsersController.$name,
                controllerAs: 'auc',
            })
            .when('/admin/users/:usernameOrId', {
                templateUrl: 'views/admin-user.html',
                controller: Controllers.AdminUserController.$name,
                controllerAs: 'auc',
            })
            .when('/admin/vno', {
                templateUrl: 'views/admin-vnos.html',
                controller: Controllers.AdminVnosController.$name,
                controllerAs: 'aoc',
            })
            .when('/admin/vno/:id', {
                templateUrl: 'views/admin-vno.html',
                controller: Controllers.AdminVnoController.$name,
                controllerAs: 'aoc',
            })
            .when('/admin/vno/:id/group/:groupId', {
                templateUrl: 'views/admin-vno-group.html',
                controller: Controllers.AdminVnoGroupController.$name,
                controllerAs: 'avgc',
            })
            .when('/admin/alarms/templates', {
                templateUrl: 'views/admin-alarms-templates.html',
                controller: Controllers.AdminAlarmsTemplatesController.$name,
                controllerAs: 'aat',
            })
            .when('/admin/alarms/templates/:deviceClass/:typeId', {
                templateUrl: 'views/admin-alarms-template.html',
                controller: Controllers.AdminAlarmsTemplatesController.$name,
                controllerAs: 'aat',
            })
            .when('/admin/alarms/specifics', {
                templateUrl: 'views/admin-alarms-specifics.html',
                controller: Controllers.AdminAlarmsSpecificsController.$name,
                controllerAs: 'aas',
            })
            .when('/admin/alarms/specifics/:deviceType/:deviceId', {
                templateUrl: 'views/admin-alarms-specific.html',
                controller: Controllers.AdminAlarmsSpecificsController.$name,
                controllerAs: 'aas',
            })
            .when('/admin/alarms/services', {
                templateUrl: 'views/admin-alarms-services.html',
                controller: Application.Controllers.AdminAlarmsServicesController.$name,
                controllerAs: 'aas',
            })
            .when('/admin/alarms/services/flexServices/:serviceId', {
                templateUrl: 'views/admin-alarms-specific.html',
                controller: Application.Controllers.AdminAlarmsServicesController.$name,
                controllerAs: 'aas',
            })
            .when('/admin/events', {
                templateUrl: 'views/admin-events.html',
                controller: Controllers.AdminEventsController.$name,
                controllerAs: 'aec',
            })
            .when('/admin/inventory/:type?', {
                templateUrl: 'views/admin-inventory.html',
                controller: Controllers.AdminInventoryController.$name,
                controllerAs: 'nno',
            })
            .when('/admin/multi-blocks', {
                templateUrl: 'views/multi-blocks.html',
                controller: Controllers.MultiBlockController.$name,
                controllerAs: 'mbc',
            })
            .when('/admin/message-translation', {
                templateUrl: 'views/admin-message-translation.html',
                controller: Controllers.MessageTranslationController.$name,
                controllerAs: 'mtc',
            })
            .when('/admin/system/system-alarms', {
                templateUrl: 'views/system-alarms.html',
                controller: Controllers.SystemAlarmsController.$name,
                controllerAs: 'sac',
            })
            .when('/admin/system/flex-services', {
                templateUrl: 'views/flex-services.html',
                controller: Controllers.FlexServicesController.$name,
                controllerAs: 'fsc',
            })
            .when('/admin/preset-paths/:type', {
                templateUrl: 'views/admin/preset-paths/preset-paths.html',
                controller: Controllers.PresetPathsController.$name,
                controllerAs: 'scc',
            })
            // default route
            .otherwise('/multiviewer');
    }
}
